import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12 1.25 21.75 4.8v5.77c0 6.1-3.78 10.29-9.75 12.18-5.97-1.89-9.75-6.08-9.75-12.18V4.8L12 1.25Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "var(--protection-plan-check-color, #fff)",
		d: "M10.43 16.88 6.22 12.66a.9.9 0 0 1 0-1.27l1.1-1.1a.9.9 0 0 1 1.27 0l2.47 2.47 5.44-5.44a.9.9 0 0 1 1.27 0l1.1 1.1a.9.9 0 0 1 0 1.27l-7.17 7.19a.9.9 0 0 1-1.27 0Z"
	})]
});
export default SvgShield;
